import { css } from 'styled-components'
import { ButtonSizes } from './Button.props'

const sizes: Record<
  ButtonSizes,
  Record<'height' | 'fontSize' | 'padding', string>
> = {
  tiny: {
    height: '36px',
    fontSize: '13px',
    padding: '10px 10px',
  },
  small: {
    height: '36px',
    fontSize: '14px',
    padding: '10px 26px',
  },
  medium: {
    height: '48px',
    fontSize: '16px',
    padding: '10px 26px',
  },
  large: {
    height: '56px',
    fontSize: '18px',
    padding: '10px 26px',
  },
}

export const defaultButtonStyle = css<{
  fullWidth: boolean
  size: ButtonSizes
}>`
  font-family: 'Work Sans';
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
  box-sizing: border-box;
  border-radius: 12px;

  padding: 0.5em;
  align-items: center;
  text-align: center;

  padding: ${({ size }) => sizes[size].padding};
  background: none;
  border: none;
  cursor: pointer;
  font-size: ${({ size }) => sizes[size].fontSize};
  font-weight: 400;
  font-style: normal;
  letter-spacing: -0.5px;
  line-height: 0.875rem;
  opacity: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ size }) => sizes[size].height};

  :disabled {
    background: #bdbbbc;
    color: ${({ theme }) => theme.colors.border};
  }
`

export const defaultIconStyle = {
  fontSize: '17px',
}
